export default "__VITE_ASSET__hH3GEeQM__"